import { render, staticRenderFns } from "./ModalCollectionTypeSelect.vue?vue&type=template&id=daa1bf28&scoped=true&"
import script from "./ModalCollectionTypeSelect.vue?vue&type=script&lang=js&"
export * from "./ModalCollectionTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./ModalCollectionTypeSelect.vue?vue&type=style&index=0&id=daa1bf28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa1bf28",
  null
  
)

export default component.exports